import React from "react";
import PropTypes from "prop-types";
import Modal from "./Modal";
import Button from "../utilComponents/Button";
import Spinner from "../utilComponents/Spinner";

const ConfirmationDialog = ({
  isVisible,
  onClose,
  onConfirm,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  loading = false,
}) => {
  return (
    <Modal isVisible={isVisible} onClose={onClose}>
      <div className="px-8 py-4">
        <h2 className="text-sm text-agBlack mb-4">{message}</h2>
        <div className="flex justify-end space-x-4">
          <Button
            variant="delete"
            fullWidth={true}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? <Spinner /> : confirmText}{" "}
            {/* Show spinner when loading */}
          </Button>
          <Button
            variant="secondary"
            fullWidth={true}
            onClick={onClose}
            disabled={loading}
          >
            {cancelText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

ConfirmationDialog.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  loading: PropTypes.bool,
};

export default ConfirmationDialog;
